module.exports = __webpack_public_path__ + "static/media/file.cdb1b475.svg";